<template>
	<el-header class="menu-page fs-cover">
		
		<!-- Nav Login -->
		<RestaurantNav
			v-if="!fixedHeader"
			:page="'branch'"
			:restaurant_uuid="restaurant_uuid"
			:branch_uuid="branch_uuid"
			:badge_editorder="BadgeEditOrder"
			@toggle_search="$emit('toggle_search')"
		/>

		<Skeleton :loading="loading">
			<!-- Loading template -->
			<template #loading>
				<el-row>
					<el-col id="restaurant_story">
						<div class="image-cover-branch color-gray80" />
						<el-row id="story" class="story">
							<div class="image-story color-gray95" />
							<div class="text-xs-center mt--5">
								<SkeletonItem variant="title" style="width: 70%;" />
							</div>
							<div class="d-flex justify-space-between mt--2">
								<SkeletonItem variant="body" style="width: 40%; " />
								<SkeletonItem variant="body" style="width: 20%; " />
							</div>
							<el-divider class="color-gray95 my--4" />
							<el-row>
								<el-col :span="3">
									<div class="shape-circle color-gray95" style="width: 32px; height: 32px;" />
								</el-col>
								<el-col :span="21">
									<div class="d-flex justify-space-between">
										<SkeletonItem variant="body" style="width: 30%;" />
										<SkeletonItem variant="body" style="width: 30%;" />
									</div>
									<div class="d-flex justify-space-between mt--2">
										<SkeletonItem variant="body" style="width: 75%;" />
										<SkeletonItem variant="body" style="width: 20%;" />
									</div>
								</el-col>
							</el-row>
						</el-row>
						<el-divider class="color-gray95 my--4 height-8" />
						<div class="pl--4">
							<div class="scrollmenu d-flex">
								<div class="active" style="width: 30%;">
									<SkeletonItem variant="body" />
								</div>
								<SkeletonItem class="ml--2" variant="body" style="width: 20%;" />
								<SkeletonItem class="ml--2" variant="body" style="width: 20%;" />
								<SkeletonItem class="ml--2" variant="body" style="width: 40%;" />
							</div>
						</div>
					</el-col>
				</el-row>
			</template>


			<!-- Content template -->
			<template>
					<!-- Branch Cover -->
					<div>
						<el-row v-if="!fixedHeader">
								<el-col id="restaurant_story" v-if="BranchDetail">
										<el-image
											class="image-cover-branch"
											:src="(BranchDetail.cover == '' || BranchDetail.cover == 'restaurant/sample_restaurant_image.png') ? require('@/assets/icons/thank/default_cover.png') : 'https://images.foodstory.co/' + BranchDetail.cover"
											fit="cover"
										>
										</el-image>
										<el-row id="story" class="story">
												<el-col>
														<el-image
															@click="gorestaurant"
															class="image-story"
															:src="'https://images.foodstory.co/' + BranchDetail.logo"
															fit="cover">
														</el-image>
												</el-col>
												<el-col>
														<el-row>
																<h2 class="text-title">{{ BranchDetail.name }}</h2>
														</el-row>
														<!-- <el-row>
																<el-col :span="18" class="fs-entry-address">
																	<label class="cl-gray-ligth-sec text-subtitle">
																		<i class="cl-gray-ligth-sec el-icon-location"/> 
																		{{ BranchDetail.address }}
																	</label>
																</el-col>
																<el-col :span="6" class="">
																	<label 
																		v-if="distance" 
																		class="cl-gray-ligth-sec text-subtitle--bold"
																	>
																		({{ distance }} km.)
																	</label>
																</el-col>
														</el-row> -->
														<el-row class="py--3">
															<el-col :span="18">
																<el-row v-if="deliveryTime.isOpen">
																	<el-col :span="24">
																		<label class="fs-block text-subtitle" >
																			<span class="color-success branch-status-container">
																				<b class="color-white--text">{{ $t('pageMenuList.header.open') }}</b>
																			</span>
																			<span v-if="nextDeliveryTime.dayId != 99">
																				{{ $t('pageMenuList.header.to') }} 
																				{{ deliveryTime.closeTime }}
																			</span>
																		</label>
																	</el-col>
																</el-row>
																<el-row v-else>
																	<el-col :span="24">
																		<label class="text-subtitle fs-block" v-if="deliveryTime.overTimeFlag"><b class="font-red">{{ $t('pageMenuList.header.close') }}</b> {{ $t('pageMenuList.header.to') }} {{ deliveryTime.timePeriod[0].openTime }}</label>
																		<label class="text-subtitle fs-block" v-else-if="!deliveryTime.overTimeFlag && nextDeliveryTime.dayId != 99 && $i18n.locale === 'en'">
																			<!-- <b class="font-red">{{ $t('pageMenuList.header.close') }}</b> -->
																			<span class="color-danger branch-status-container">
																				<b class="color-white--text">{{ $t('pageMenuList.header.close') }}</b>
																			</span>
																			{{ $t('pageMenuList.header.to') }} {{ nextDeliveryTime.dayId | filterDayEN }} {{nextDeliveryTime.openTime}}
																		</label>
																		<label class="text-subtitle fs-block" v-else-if="!deliveryTime.overTimeFlag && nextDeliveryTime.dayId != 99 && $i18n.locale !== 'en'">
																			<!-- <b class="font-red">{{ $t('pageMenuList.header.close') }}</b> -->
																			<span class="color-danger branch-status-container">
																				<b class="color-white--text">{{ $t('pageMenuList.header.close') }}</b>
																			</span>
																			{{ $t('pageMenuList.header.to') }} {{ nextDeliveryTime.dayId | filterDayTH }} {{nextDeliveryTime.openTime}}
																		</label>
																		<label class="text-subtitle fs-block" v-else>
																			<!-- <b class="font-red">{{ $t('pageMenuList.header.close') }}</b> -->
																			<span class="color-danger branch-status-container">
																				<b class="color-white--text">{{ $t('pageMenuList.header.close') }}</b>
																			</span>
																		</label>
																	</el-col>
																</el-row>
															</el-col>
															<el-col :span="6">
																<div class="text-xs-end">
																	<span 
																		@click="$emit('toggle_branch_detail_drawer')"
																		class="color-primary--text text-subtitle--med"
																	>
																		{{ $t('pageMenuList.header.moreInfo') }}
																	</span>
																</div>
															</el-col>
														</el-row>
												</el-col>
										</el-row>
								</el-col>
						</el-row>

						<!-- Tab Delivery & Pickup -->
						<el-row class="tab-destination" v-if="BranchDetail && !fixedHeader">
								<el-col id="dual-flag" :span="24" class="flex" v-if="BranchDetail.pickupFlag === '1' && BranchDetail.deliveryFlag === '1'">
									<BaseButton  
										class="text-heading3 primary"
										@click="isDeliverySelected = true" 
										:class="isDeliverySelected ? 'active': 'color-gray59--text'"
									>
										<template #prefix>
											<img 
												class="mr--2"
												:src="isDeliverySelected ? 
													require('@/assets/icons/delivery_active.png') : 
													require('@/assets/icons/delivery_inactive.png')
												" 
												width="22" 
												height="22" 
											/>
										</template>
										{{ $t('pageMenuList.header.deliveryFlag') }}
									</BaseButton>
									<BaseButton 
										class="text-heading3 primary"
										@click="isDeliverySelected = false" 
										:class="!isDeliverySelected ? 'active': 'color-gray59--text'"
									>
										<template #prefix>
											<img 
												class="mr--1 mb--1"
												:src="!isDeliverySelected ? 
													require('@/assets/icons/pickup_active.png') : 
													require('@/assets/icons/pickup_inactive.png')
												" 
												width="22" 
												height="22" 
											/>
										</template>
										{{ $t('pageMenuList.header.pickupFlag') }}
									</BaseButton>
								</el-col>
								<el-col :span="24" v-else>
									<el-row> 
										<el-col :span="3">
											<img 
												class="mt--1"
												:src="isDeliverySelected ? 
													require('@/assets/icons/svg/delivery-active.svg') : 
													require('@/assets/icons/svg/pickup-active.svg')
												" 
											/>
										</el-col>
										<el-col :span="21">
											<div class="d-flex justify-space-between">
												<span class="color-charcoal--text text-subtitle--bold">
													{{ 
														isDeliverySelected ? 
															$t('pageMenuList.header.deliveryFlag') : 
															$t('pageMenuList.header.pickupFlag') 
													}}
												</span>
												<div v-if="distanceInfo">
													<img 
														v-show="isPriceShown" 
														:src="require('@/assets/icons/svg/delivery-gray.svg')" 
													/>
													<label 
														v-show="isPriceShown" 
														class="color-charcoal--text text-subtitle"
													>
														{{ distanceInfo.price | priceFormat(0,$store.getters.currency)}}
														<span class="color-charcoal--text mx--1">•</span>
													</label>
													<label v-if="Number.isFinite(distanceInfo.dis_metre)" class="color-charcoal--text text-subtitle">
														{{ distanceInfo.dis_metre }} {{ $t('global.kilometer') }}
													</label>
												</div>
											</div>
											<div 
												class="full-width truncate mt--1" 
												@click="isDeliverySelected ? 
													$emit('toggle_map') : 
													goToGoogleMap()
												"
											>
												<label class="color-charcoal--text text-subtitle">
													<img 
														class="mr--1" 
														:src="require('@/assets/icons/svg/pointer-active.svg')" 
													/>
													{{ isDeliverySelected ? address || $t('pageMenuList.header.selectAddress') : BranchDetail.address }}
		    									<el-divider class="ml--4 my--0" />
												</label>
											</div>
										</el-col>
									</el-row>
								</el-col>
						</el-row>

						<!-- Map -->
						<el-row class="px-4 mt--4" v-if="!fixedHeader && hasDeliveryAndPickupService">
							<el-col :span="isDeliverySelected ? 16 : 19" class="fs-entry-address" @click.native="isDeliverySelected && $emit('toggle_map')">
								<label class="color-charcoal--text text-subtitle">
									<img class="mr--1" :src="require('@/assets/icons/svg/pointer-active.svg')" />
									{{ isDeliverySelected ? address || $t('pageMenuList.header.selectAddress') : BranchDetail.address }}
		    					<el-divider class="ml--4 my--0" />
								</label>
							</el-col>
							<el-col :span="isDeliverySelected ? 8 : 5" class="text-xs-end">
								<div v-if="distanceInfo">
									<img v-show="isDeliverySelected" :src="require('@/assets/icons/svg/delivery-gray.svg')" />
									<label 
										v-show="isDeliverySelected && distanceInfo.price && distanceInfo.status === 'normal'" 
										class="color-charcoal--text text-subtitle"
									>
										{{ distanceInfo.price | priceFormat(0,$store.getters.currency)}}
										<span>•</span>
									</label>
									<label v-if="distanceInfo.dis_metre" class="color-charcoal--text text-subtitle">
										{{ distanceInfo.dis_metre }} {{ $t('global.kilometer') }}
									</label>
								</div>
							</el-col>
						</el-row>

						<el-row id="top-header" class="fs-sticky-header" v-if="BranchDetail && fixedHeader">
							<el-col :span="4">
									<el-image @click="gorestaurant" class="restaurant-logo"
											width="50"
											height="50"
											:src="'https://images.foodstory.co/' + BranchDetail.logo"
											fit="cover"></el-image>
							</el-col>
							<el-col :span="11">
									<div class="head-branch_name" @click="gorestaurant">{{BranchDetail.name}} </div>
							</el-col>
							<el-col :span="3" v-if="!UserLogin" style="height: 20px;"></el-col>
							<el-col :span="3"><a @click="$emit('toggle_search')"><img src="@/assets/icons/search.png" class="fs-nav-icon-b pointer"></a></el-col>
							<el-col :span="3" v-if="UserLogin">
								<a @click="redirectToLastesOrder">
									<img v-if="BadgeEditOrder > 0" src="@/assets/icons/receipt_noti.png" class="fs-nav-icon-b pointer">
									<img v-else src="@/assets/icons/receipt.png" class="fs-nav-icon-b pointer">
								</a>
							</el-col>
							<el-col :span="3">
								<a class="btn-profile" v-if="!UserLogin" @click="redirectToLogin" >
									<img src="@/assets/icons/profile.png" class="fs-nav-icon-b pointer">
								</a>
								<a class="btn-profile" v-if="UserLogin" @click="toggleDisplayProfile">
									<img src="@/assets/icons/profile.png" class="fs-nav-icon-b pointer">
								</a>
							</el-col>
						</el-row>

						<el-divider class="color-whitesmoke divider-large mb--0 mt--4" />
						<!-- Tab Category -->
						<div id="tab-category">
							<div class="scrollmenu" id="scrollmenu">
								<a 
									v-for="(item,index) in menuFilter" 
									v-show="item.menus.length > 0" 
									:key="'tab-item-'+index" 
									:id="'tab-item-'+index" 
									class="text-heading2--bold"				
									:class="{
										'active': category_select == index
									}" 
									@click="handleClick(item.name, index)"
								>
									{{item.name}}
								</a>
							</div>
						</div>
					</div>
			</template>
		</Skeleton>
	</el-header>
</template>

<script>
function elementInViewport(el) {
  var top = el.offsetTop + 380;
  var height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
  }

  return (
    top >= window.pageYOffset &&
    (top + height) <= (window.pageYOffset + window.innerHeight)
  );
}

import firebase from 'firebase/app'
import Mixins from '@/utils/mixins'
import RestaurantNav from "@/components/restaurant/RestaurantNav"

export default {
	name: 'MenuHeader',
	components: {
		RestaurantNav
	},
	mixins: [Mixins],
	props: {
		restaurant_uuid: { 	default: '' },
		branch_uuid: { default: '' },
		address: { default : '' },
		distance: {	default: null },
		fixedHeader: { default : false },
		menu_data: { default: () => ([]) },
		filterMenuFromGroup: { default: () => ([]) },
		loading: { default: false }
	},
	data() {
		return {
			category_select: 0,
			isDelivery: true,
			UserLogin: false,
			displayProfile: false,
			isClick: false
		}
	},
	created() {
			document.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
			document.removeEventListener('scroll', this.handleScroll);
	},
	mounted: async function() {
			// Check Login
		this.$store.dispatch('onAuthStateChanged').then((user) => {
			this.UserLogin = user
			if (user) {
				this.$store.dispatch('getBadgeEditOrder', {
					restaurant_uuid: this.BranchDetail.restaurantId,
					branch_uuid: this.BranchDetail.id
				})
				this.$store.dispatch('getUserInfo')
			}
		})

		window.scrollTo(0,0)
	},
	methods: {
		goToGoogleMap: function() {
			const location = this.BranchDetail.latitude + ',' + this.BranchDetail.longitude
			return window.open('https://www.google.com/maps/search/?api=1&query=' + location)
		},
		logoutUser() {
			firebase.auth().signOut()
			this.$router.go(0)
		},
		handleClick(tab, index) {
			if (!this.isClick) {
				this.isClick = true;
				const id = 'category-head-'+tab;
				let yOffset = this.isDeliverySelected ? -240 : -180;
				const element = document.getElementById(id);
				let clientTop = element.getBoundingClientRect().top
				let y = clientTop + window.pageYOffset + yOffset;
				if (y > 300) {
					yOffset = this.fixedHeader ? -140 : (this.isDeliverySelected ? -285 : -240)
					y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
				}

				if (this.category_select != index)
				window.scrollTo({top: y, behavior: 'smooth'});
				this.category_select = index
				let time = 500;
				if (Math.abs(clientTop) > 3000) {
					time = 1000
				}
				if (Math.abs(clientTop) > 6000) {
					time = 1500
				}
				if (Math.abs(clientTop) > 10000) {
					time = 2000
				}

				setTimeout(() => {
					this.isClick = false;
				}, time);
			}
		},
		redirectToLogin() {
			this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/verify/phonenumber` })
		},
		redirectToLastesOrder() {
			this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/order/history` })
		},
		toggleDisplayProfile() {
			this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/profile` })
		},
		handleScroll() {
			if(!this.isClick){
				if (!_.isNil(this.menuFilter)) {
					this.menuFilter.map((item) => item.name).find((name,index) => {
						const el = document.getElementById('category-head-'+ name)
						if(elementInViewport(el)) {
							this.category_select = index
							// if (!index) {
							// 	scrollmenu.scrollTo({
							// 		left: 0,
							// 		behavior: 'smooth'
							// 	})
							// } else {
							// 	const tabElement = document.getElementById('tab-item-' + index)
							// 	tabElement && scrollmenu.scrollTo({
							// 		left: tabElement.offsetLeft,
							// 		behavior: 'smooth'
							// 	})
							// }
							// if (index != 0) {
							// 	document.getElementById('tab-item-'+index).scrollIntoView({ behavior: 'smooth' })
							// } else {
							// 	scrollmenu.scrollTo({
							// 		top: 0,
							// 		left: 0,
							// 		behavior: 'smooth'
							// 	})
							// }
						}
					})
				}
			}
		},
		gorestaurant() {
			this.$router.push({ path: `/restaurant/${this.restaurant_uuid}` })
		},
	},
	computed: {
		isPriceShown: function() {
			return this.isDeliverySelected && Number.isFinite(this.distanceInfo.price) && this.distanceInfo.status === 'normal'
		},
		hasDeliveryAndPickupService: function() {
			return this.BranchDetail.deliveryFlag == 1 && this.BranchDetail.pickupFlag == 1
		},
		distanceInfo: function() {
			return this.$store.getters.DistanceInfo
		},
		deliveryTime: function() {
			return this.BranchDetail.deliveryTime || {}
		},
		nextDeliveryTime: function() {
			return this.BranchDetail.nextDeliveryTime || {}
		},
		UserToken () {
			return this.$store.getters.UserToken
		},
		UserInfo () {
			return this.$store.getters.UserInfo
		},
		BranchDetail() {
			const branchDetail = this.$store.getters.BranchDetail

			if (!branchDetail) return {}

			const hasTwoServices = branchDetail.deliveryFlag == 1 && branchDetail.pickupFlag == 1
			if (hasTwoServices) {
				const receivingType = JSON.parse(localStorage.getItem('send-' + branchDetail.id))
				if (receivingType) {
					this.isDeliverySelected = receivingType === 'delivery'
				}
			} else {
				this.isDeliverySelected = branchDetail.deliveryFlag == 1
			}

			return branchDetail
		},
		BadgeEditOrder () {
			return this.$store.getters.BadgeEditOrder
		},
		menuFilter() {
			if(this.menu_data){
				return this.menu_data.filter(item => item.menus.length > 0)
			}
		},
		isDeliverySelected: {
			get: function() {
				return this.isDelivery
			},
			set: function(value) {
				if (value) {
					this.$store.dispatch('setDelivery', 'delivery')
				} else {
					this.$store.dispatch('setDelivery', 'pick-up')
				}
				this.isDelivery = value
			}
		}
	},
	watch: {
		category_select: function(value) {
			const tabElement = document.getElementById('tab-item-' + value)
			return tabElement && scrollmenu.scrollTo({
				left: tabElement.offsetLeft,
				behavior: 'smooth'
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.el-button+.el-button {
	margin-left: 0;
}

.height-8 {
	height: 8px;
}

.branch-status-container {
	padding-left: 12px;
	padding-right: 12px;
	border-radius: 4px;
	margin-right: 5px;
}

div.scrollmenu {
background-color: #fff;
overflow: auto;
white-space: nowrap;
box-shadow: 0px 2px 4px rgba(202, 202, 202, 0.2);
}

div.scrollmenu a {
display: inline-block;
padding: 14px 14px 11px;
text-decoration: none;
font-weight: normal;
font-size: 16px;
line-height: 24px;
text-align: center;

color: #BDBDBD;
}

.scrollmenu .active {
		font-weight: 500;
		border-bottom: 3px solid #28B7FF;
		opacity: 1;
		-webkit-animation: md-tab-ripple 0.5s linear forwards;
		animation: md-tab-ripple 0.5s linear forwards;

		color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/menu/MenuHeader.vue